var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.channel)?_c('span',[_c('i',{staticClass:"fa fa-circle color-preview",style:({color: _vm.color})}),_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }